// src/components/SuccessPage.jsx
import React, { useEffect, useState } from "react";
import { CheckCircle, Clipboard as CopyIcon, Home } from "lucide-react";

const SuccessPage = ({ isMobile, zipUrl, submittedItems, submittedTotal, notesInput, usbDriveOption }) => {
  const [countdown, setCountdown] = useState(60);
  const copyToClipboard = () => navigator.clipboard?.writeText(zipUrl);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          // Navigate to home after countdown
          window.location.href = "/";
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // Cleanup timer on unmount
    return () => clearInterval(timer);
  }, []);

  const handleGoHome = () => {
    window.location.href = "/";
  };

  return (
    <div className={`cart-page ${isMobile ? "mobile-no-keyboard" : ""}`}>
      <div className="success-container">
        <CheckCircle className="success-icon" size={64} />
        <h2>Order Submitted Successfully!</h2>

        {zipUrl ? (
          <>
            <div className="zip-link">
              <p>Your files are ready:</p>
              <a
                href={zipUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="zip-url"
              >
                {zipUrl}
              </a>
              {navigator.clipboard && (
                <button className="copy-btn" onClick={copyToClipboard}>
                  <CopyIcon size={16} /> Copy
                </button>
              )}
            </div>
            <div className="confirmation-note">
              <p>
                Please go to the <strong>service counter</strong> to complete your transaction.
              </p>
              {notesInput && (
                <div className="order-notes">
                  <h4>Order Notes:</h4>
                  <p>{notesInput}</p>
                </div>
              )}
            </div>
          </>
        ) : (
          <div className="confirmation-note">
            <p>
              Your order has been submitted successfully!
            </p>
            {notesInput && (
              <div className="order-notes">
                <h4>Order Notes:</h4>
                <p>{notesInput}</p>
              </div>
            )}
          </div>
        )}

        <div className="order-summary">
          <h3>Your Order:</h3>
          <div className="order-items-list">
            {submittedItems.some(item => item.url) && submittedItems.length > 0 && (
              <div className="order-items-section">
                <h4>Media: {submittedItems.length}</h4>
              </div>
            )}
            {submittedItems.some(item => !item.url) && (
              <div className="order-items-section">
                <h4>Items:</h4>
                <ul>
                  {submittedItems
                    .filter(item => !item.url)
                    .map((item, i) => (
                      <li key={i}>{item.title}</li>
                    ))}
                </ul>
              </div>
            )}
          </div>
          {usbDriveOption && (
            <div className="order-charge-item">
              <span>USB Drive:</span>
              <span>$10.00</span>
            </div>
          )}
          <p className="order-total">
            <strong>Total: ${usbDriveOption ? (Number(submittedTotal) + 10).toFixed(2) : Number(submittedTotal).toFixed(2)}</strong>
          </p>
          <p className="tax-note">
            *Taxes not included - will be calculated at register
          </p>
        </div>

        <div className="success-actions">
          <Home 
            className="home-icon-link" 
            size={48} 
            onClick={handleGoHome}
            style={{ cursor: 'pointer' }}
          />
          <p className="countdown-text">
            Auto-navigating to home in {countdown} seconds...
          </p>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;
